<cf-shell-lib-named-router-outlet
  [name]="instance.outletName"
  (activate)="onActivate($event)"
  (deactivate)="onDeactivate()"
></cf-shell-lib-named-router-outlet>
